import {
    ACCOR_BUTTON,
    LOAD_MORE_BUTTON
} from "../constants/elementConst";
import {renderIfTrue} from "../features/tools";
import store from "../store";

const splitPhone = (phoneNumber) => {
    const arrOfNumber = phoneNumber.split("/");

    return arrOfNumber.map((num,index) => {
        let className = "employee_register--pb-5";

        if (index === arrOfNumber.length-1){
            className = "";
        }

        return `
            <div class="${className}">
                <span class="budicon budicon-call" aria-hidden="true"></span>
                <a href="tel:${num}" class="employee_register__link--blue">
                    ${num}
                </a>                            
            </div>
        `
    }).join("");
};

const phone = (phoneNumber) => {
    return `
        <span class="budicon budicon-call" aria-hidden="true"></span>
        <a href="tel:${phoneNumber}" class="employee_register__link--blue">
            ${phoneNumber}
        </a>                            
    `;
};

export const usersTemplate = () => {

    const userList = store.get("userList");
    const searchOptionNext = store.get("searchOptionNext");

    const shouldRenderNext = [`
        ${renderIfTrue(searchOptionNext, () => `
            <button class="employee_register__load-more employee_register--bg--grey-400" 
                type="button" 
                data-click="${LOAD_MORE_BUTTON}"
                data-js="${LOAD_MORE_BUTTON}">
                Last flere ...
            </button>
        `)}
    `];

    const userListData =  userList.map(user => `
        <div class="employee_register__accordion">
            <div class="">
                <button id="employee_register__accordion__button-${user.UserId}" 
                    class="btn employee_register__btn-link employee_register--w-100 employee_register__accordion__button employee_register--px-40 employee_register--pt-20 employee_register--pb-15"
                    data-toggle="employee_register__accordion-${user.UserId}" 
                    data-js="${ACCOR_BUTTON}"
                    data-click="${ACCOR_BUTTON}"
                    aria-expanded="false"
                >    
                    <header class="employee_register__card">
                        <div class="employee_register--pb-5">
                            <strong class="employee_register__card-title">
                                ${user.GivenName} 
                                ${user.SurName}
                            </strong>
                            <span class="budicon budicon-chevron-bottom employee_register__accordion__icon employee_register--float-right employee_register__icon--adjust-5" 
                                aria-hidden="true">
                            </span>
                        </div>
                        
                        <div class="employee_register__card-sub-title employee_register--pb-5 employee_register__text--grey">
                            ${user.Department} 
                            ${renderIfTrue(user.Title, () => `
                                , ${user.Title}
                            `)}
                        </div>
                    </header>
                </button>
                
                <div class="employee_register__accordion--collapse employee_register--px-40 employee_register--pb-15 employee_register--font-size-16" 
                    data-js="employee_register__accordion-${user.UserId}">
                    ${renderIfTrue(user.Section, () => `
                        <div class="employee_register--pb-15 employee_register__text--grey">
                            ${user.Section}
                        </div>
                    `)}
             
                    ${renderIfTrue(user.Phone, () => `
                        <div class="employee_register--pb-15"> 
                            ${store.get("multiPhoneSupport") ? splitPhone(user.Phone) : phone(user.Phone)}
                        </div>
                    `)}
                    
                    ${renderIfTrue(user.Email, () => `
                        <div>
                            <span class="budicon budicon-email" aria-hidden="true"></span>
                            <a href="mailto:${user.Email}" target="_top" class="employee_register__link--blue">
                                ${user.Email}
                            </a>
                        </div>
                    `)}
                </div>
            </div>
        </div>
    `);

    return [...userListData,...shouldRenderNext].join("");
};